// export default Accueil;
import React, { useEffect, useState } from "react";
import AccountLayout from "../../blocs/AccountLayout";
import CardRdv from "../../components/CardRdv";
import ListAvis from "../../components/ListAvis";
import { useDispatch, useSelector } from "react-redux";
import { fetchRendezvousByStatus } from "../../store/slices/rendezVousPrestaSlice";
import AcceilPrestaSkeleton from "../../components/skeletons/AcceilPrestaSkeleton";
import { useNavigate } from "react-router-dom";
import { fetchReviews, selectReviews } from "../../store/slices/avisSlice";
import { fetchKpis } from "../../store/slices/kpiSlice";
import { create, get } from "../../services/services";
import { updateUserData } from "../../store/slices/userSlice";

function Accueil() {
  const [isSigning, setIsSigning] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("week");
  const dispatch = useDispatch();
  const {
    enAttente = [],
    confirmes = [],
    status,
  } = useSelector((state) => state.rdvPresta || {});

  const reviews = useSelector(selectReviews);
  const { user } = useSelector((state) => state.user);
  const idEtablissement = user?.etablissement?.id;
  const kpi = useSelector((state) => state?.kpi?.data?.kpis);

  useEffect(() => {
    dispatch(fetchKpis({ period: selectedPeriod }));
  }, [dispatch, selectedPeriod]);

  useEffect(() => {
    if (idEtablissement) {
      dispatch(fetchReviews({ idEtablissement }));
    }
    get("user/profile")
      .then((res) => {
        const { user } = res?.data;
       
        dispatch(updateUserData({ user }));
      })
      .catch((err) => {
        // console.log(err);
      });
  }, [dispatch, idEtablissement]);

  const navigate = useNavigate();


  const signeContract = () => {
    setIsSigning(true);
    create({}, "docage/full_transaction")
      .then((res) => {
        if (res?.data?.redirect_url) {
          // window.open(res.data.redirect_url);
          // redirection in the same tab (pb refresh le 30-09)
          window.location.href = res.data.redirect_url;
        }
      })
      .catch((err) => { })
      .finally(() => {
        setIsSigning(false);
      });
  };

  useEffect(() => {
    dispatch(fetchRendezvousByStatus());
  }, [dispatch]);

  if (status === "loading")
    return (
      <AccountLayout>
        {" "}
        <AcceilPrestaSkeleton />{" "}
      </AccountLayout>
    );

  return (
    <AccountLayout>
      {(user?.etablissement?.is_complete === "0") && (
          <div className="row mb-32">
            <div className="frame">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 w-100">
                <div className="d-flex align-items-center gap-3">
                  <img src="/images/check.svg" alt="check icon" />
                  <div>
                    <h6>Vous n’êtes pas encore visible sur Twyny</h6>
                    <p className="body">
                      Complétez entièrement votre compte afin d'être visible sur
                      TWYNY.
                    </p>
                  </div>
                </div>

                <div className="d-flex">
                  {/* {user?.signature_status !== "5" && (
                    <button
                      className="twyny-cta-primary mr-8"
                      onClick={() => signeContract()}
                      disabled={isSigning}
                    >
                      {isSigning ? "Signature en cours..." : "Signer le contrat"}{" "}
                    </button>
                  )} */}
                  {user?.etablissement?.is_complete === "0" && ( // Used === for strict equality
                    <button
                      className=" twyny-cta-secondary "
                      onClick={() =>
                        navigate("/compte/prestataire/page-etablissement")
                      }
                    >
                      Compléter ma page
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

      <div className="row gy-2 gx-3">
        {/* Premier bloc : reste col-12 sur petit écran, col-md-4 à partir de md */}
        <div className="col-12 col-md-4 frame-kpi">
          <div className="d-flex justify-content-between align-items-start">
            <p className="body mb-7">Chiffre d’affaires</p>
            <select
              id="periode"
              className="form-control frame-select mb-7"
              value={selectedPeriod}
              onChange={(e) => setSelectedPeriod(e.target.value)}
            >
              <option value="week">Semaine</option>
              <option value="month">Mois</option>
              <option value="year">Année</option>
            </select>
          </div>
          <h3>{kpi?.revenue?.total}€</h3>
        </div>

        {/* Bloc 2 */}
        <div
          className="col-12 col-md frame-kpi margin-bloc"
          onClick={() => navigate("/compte/prestataire/rendez-vous")}
          style={{ cursor: "pointer" }}
        >
          <p className="body mb-16">Nombre de rdv</p>
          <div className="d-flex justify-content-between">
            <h3>{kpi?.appointments?.total}</h3>
            <img src="/images/fleche-blue.svg" alt="voir" />
          </div>
        </div>

        {/* Bloc 3 */}
        <div
          className="col-12 col-md frame-kpi margin-bloc"
          onClick={() => navigate("/compte/prestataire/avis-clients")}
          style={{ cursor: "pointer" }}
        >
          <p className="body mb-16">Nombre d’avis</p>
          <div className="d-flex justify-content-between">
            <h3>{kpi?.reviews?.count}</h3>
            <img src="/images/fleche-blue.svg" alt="voir" />
          </div>
        </div>

        {/* Bloc 4 */}
        <div
          className="col-12 col-md frame-kpi margin-bloc"
          onClick={() => navigate("/compte/prestataire/avis-clients")}
          style={{ cursor: "pointer" }}
        >
          <p className="body mb-16">Note moyenne</p>
          <div className="d-flex justify-content-between">
            <h3>{kpi?.reviews?.average_score}</h3>
            <img src="/images/fleche-blue.svg" alt="voir" />
          </div>
        </div>
      </div>

      {/* Prochains rendez-vous  */}
      <div className="d-flex justify-content-between mt-32 mb-16 pl-0 pr-0">
        <h5>Prochains rendez-vous</h5>
        <a href="/compte/prestataire/agenda" className="link-blue text-end">
          Voir mon agenda
        </a>
      </div>
      {confirmes && confirmes.length > 0 ? (
        <div className="row gy-2 gx-3">
          {confirmes.slice(0, 2).map((rdv, index) => (
            <CardRdv key={index} rdvDetails={rdv} />
          ))}
          {confirmes.length === 1 && (
            <div className="col-12 col-sm-12 col-lg-6 mt-16">
              <div className="empty-frame mr-0 d-flex align-items-center justify-content-center">
                <p className="body grey-light">
                  Vous n’avez pas d’autre rendez-vous pour le moment
                </p>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="frame d-flex align-items-center justify-content-center">
          <p className="body">Vous n’avez pas encore de rendez-vous planifié</p>
        </div>
      )}
      {/* Dernières demandes  */}
      <div className="d-flex justify-content-between mt-32 mb-16 pl-0 pr-0">
        <h5>Dernières demandes ({enAttente?.length})</h5>
        <a href="/compte/prestataire/demande-rendez-vous" className="link-blue text-end">
          Voir toutes les demandes
        </a>
      </div>
      {enAttente && enAttente.length > 0 ? (
        <div className="row">
          {enAttente.slice(0, 2).map((rdv, index) => (
            <CardRdv key={index} rdvDetails={rdv} />
          ))}
          {enAttente.length === 1 && (
            <div className="col-12 col-sm-12 col-lg-6 mt-16">
              <div className="frame  d-flex align-items-center justify-content-center">
                <p className="body grey-light">
                  Vous n’avez pas d’autre demande de rendez-vous pour le moment
                </p>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="frame frame-height">
          <p className="body">Vous n’avez pas encore de rendez-vous planifié</p>
        </div>
      )}

      {/* Derniers avis */}
      <div className="d-flex justify-content-between mt-32 mb-16 pl-0 pr-0">
        <h5>Derniers avis ({reviews.length})</h5>
        <a href="/compte/prestataire/avis-clients" className="link-blue text-end">
          Voir tous les avis
        </a>
      </div>

      {reviews && reviews.length > 0 ? (
        <ListAvis />
      ) : (
        <div className="frame">
          <p className="body">Vous n’avez pas encore d’avis client</p>
        </div>
      )}
    </AccountLayout>
  );
}

export default Accueil;